import pluralize from 'pluralize';

pluralize.addIrregularRule('it', 'them');

export default pluralize;
